import { render, staticRenderFns } from "./ExchangeList.vue?vue&type=template&id=40d8532d&scoped=true"
import script from "./ExchangeList.vue?vue&type=script&lang=js"
export * from "./ExchangeList.vue?vue&type=script&lang=js"
import style0 from "./ExchangeList.vue?vue&type=style&index=0&id=40d8532d&prod&scoped=true&lang=css"
import style1 from "./ExchangeList.vue?vue&type=style&index=1&id=40d8532d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d8532d",
  null
  
)

export default component.exports